<script setup>
import { ref } from 'vue'
import NavLink from './NavLink.vue'
import CollapsibleNavItem from './CollapsibleNavItem.vue'

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  level: {
    type: Number,
    default: 0,
  },
})

// Create a map of open states for each dropdown item
const openStates = {}
props.items.forEach(item => {
  if (item.component === 'Dropdown') {
    openStates[item.id] = ref(false)
  }
})
</script>

<template>
  <template v-for="item in items" :key="item.id">
    <!-- Link Item -->
    <NavLink
      v-if="item.component === 'Link'"
      :key="'Link-' + item.id"
      :item="item"
      :level="level"
    />

    <!-- Nested Dropdown (as Collapsible) -->
    <div v-else-if="item.component === 'Dropdown'" :key="'Dropdown-' + item.id">
      <CollapsibleNavItem
        :item="item"
        v-model:isOpen="openStates[item.id].value"
        :level="level"
      >
        <div>
          <!-- Recursively render the next level -->
          <RecursiveAccordion
            :items="item.items"
            :level="level + 1"
          />
        </div>
      </CollapsibleNavItem>
    </div>

    <!-- Label Item -->
    <div v-else-if="item.component === 'Label'" :key="'label-' + item.id" class="text-sm font-semibold">
      {{ item.name }}
    </div>
  </template>
</template>
